function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { classnames } from '@bydesign-ui/utils';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useLocale, usePrefixCls } from '@byte-design/config';
import { useUpload } from '../rc-upload/hooks/useUpload';
import { UploadOne as Upload2 } from './../../../common/icons';
export var isAccept = function isAccept(file, accept) {
  if (!file || !accept) {
    return true;
  }

  var acceptArray = Array.isArray(accept) ? accept : accept.split(',');
  var _file$name = file.name,
      name = _file$name === void 0 ? '' : _file$name,
      _file$type = file.type,
      type = _file$type === void 0 ? '' : _file$type;
  var fileName = name.toLowerCase().trim();
  var fileType = type.toLowerCase().trim();
  var baseFileType = fileType.replace(/\/.*$/, '');

  var _iterator = _createForOfIteratorHelper(acceptArray),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var acceptStr = _step.value;

      var _accept = acceptStr.toLowerCase().trim();

      if (_accept === fileType || _accept === '*') {
        return true;
      }

      if (_accept.charAt(0) === '.' && fileName.endsWith(_accept)) {
        return true;
      }

      var acceptBaseType = _accept.replace(/\/.*$/, '');

      if (/\/\*$/.test(_accept) && acceptBaseType === baseFileType) {
        return true;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return false;
};

var filesAcceptFilter = function filesAcceptFilter(fileList, accept) {
  var result = [];

  for (var _i = 0, _Array$from = Array.from(fileList); _i < _Array$from.length; _i++) {
    var file = _Array$from[_i];
    isAccept(file, accept) && result.push(file);
  }

  return result;
};

export function DropTrigger(_ref) {
  var accept = _ref.accept,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      desc = _ref.desc;
  var fileUpload = useUpload();
  var dropArea = useRef(null);
  var target = null;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isActive = _useState2[0],
      setActive = _useState2[1];

  var leave = useCallback(function (ev) {
    if (target === ev.target) {
      setActive(false);
    }
  }, []);
  var drop = useCallback(function (ev) {
    if (disabled) return;
    leave(ev);
    var fileList = ev.dataTransfer.files;
    var acceptFileList = filesAcceptFilter(fileList, accept);

    if (multiple) {
      fileUpload.addFiles(acceptFileList);
    } else if (acceptFileList[0]) {
      fileUpload.addFiles(acceptFileList.slice(0, 1));
    }

    ev.preventDefault();
    ev.stopPropagation();
  }, [disabled]);
  var enter = useCallback(function (ev) {
    if (disabled) return false;
    target = ev.target;
    setActive(true);
  }, [disabled]);
  var locale = useLocale('upload.drop');
  var localeClick = useLocale('upload.click');
  var cls = classnames(usePrefixCls('upload-drop-trigger', {
    disabled: disabled
  }), {
    active: isActive
  });
  var infoCls = usePrefixCls('upload-drop-trigger-info');
  var textCls = usePrefixCls('upload-drop-trigger-text');
  var specialTextCls = usePrefixCls('upload-drop-trigger-special-text');
  var uploadIconCls = usePrefixCls('upload-drop-trigger-upload');
  useEffect(function () {
    var preventDefault = function preventDefault(ev) {
      ev.preventDefault();
    };

    document.addEventListener('drop', preventDefault);
    document.addEventListener('dragover', preventDefault);
    return function () {
      document.removeEventListener('drop', preventDefault);
      document.removeEventListener('dragover', preventDefault);
    };
  });
  return React.createElement("div", {
    ref: dropArea,
    className: cls,
    onDrop: drop,
    onDragEnter: enter,
    onDragLeave: leave
  }, React.createElement("div", {
    className: infoCls
  }, React.createElement(Upload2, {
    className: uploadIconCls,
    size: "36px"
  }), React.createElement("div", {
    className: textCls
  }, desc || locale, !desc && React.createElement("span", {
    className: specialTextCls
  }, localeClick))));
}